import React from "react";
import CloseIcon from "@mui/icons-material/Close";
import { RespuestaLeerPropietarios } from "../../../services/propietariosServicios";

export const PropietarioIndividual = ({
  propietario,
  onEliminar,
}: {
  propietario: RespuestaLeerPropietarios;
  onEliminar: (p: RespuestaLeerPropietarios) => void;
}) => {
  return (
    <div className="d-flex gap-2 border rounded py-1 px-2">
      <span className="align-middle">{propietario.nombres}</span>
      <div role="button">
        <CloseIcon
          onClick={() => {
            onEliminar(propietario);
          }}
          sx={{ fontSize: 20 }}
        />
      </div>
    </div>
  );
};
